import store from "../../redux_config/store";

export const headers = () => {
  const state = store?.getState();
  const token = state?.auth?.token;

  if (token) {
    return {
      "Content-Type": "application/json; charset=utf-8",
      "access-token": token,
    };
  } else {
    return {};
  }
};

export const formDataHeaders = () => {
  const state = store?.getState();
  const token = state?.auth?.token;

  if (token) {
    return {
      "Content-Type": "multipart/form-data",
      "access-token": token,
    };
  } else {
    return {};
  }
};
